// Hjelpere for tidssporing.

// Kompakt varighet, f.eks. "1t 30m", "45m", "2t".
export const formatDuration = (totalSeconds: number): string => {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h && m) return `${h}t ${m}m`;
  if (h) return `${h}t`;
  return `${m}m`;
};

// Løpende klokke for en aktiv timer, f.eks. "1:05:09".
export const formatClock = (totalSeconds: number): string => {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${h}:${pad(m)}:${pad(sec)}`;
};

// Sekunder i en (avsluttet eller løpende) oppføring.
export const entrySeconds = (
  startedAt: string,
  endedAt: string | null | undefined,
  nowMs: number = Date.now(),
): number => {
  const start = new Date(startedAt).getTime();
  const end = endedAt ? new Date(endedAt).getTime() : nowMs;
  return Math.max(0, (end - start) / 1000);
};
